import environment from 'src/app/environment';


const errorLoggerConfiguration = {
  ignoreErrors: [
    'ServiceWorker',
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage'
  ],
  ignoreUrls: [
    // Facebook flakiness
    /graph\.facebo{2}k\.com/i,
    // Facebook blocked
    /con{2}ect\.facebo{2}k\.net\/en_us\/al{2}\.js/i,
    // Woopra flakiness
    /eatdif{2}erent\.com\.wo{2}pra-ns\.com/i,
    /static\.wo{2}pra\.com\/js\/wo{2}pra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/{2}/i,
    /^chrome-extension:\/{2}/i,
    // Other plugins
    /127(?:\.0){2}\.1:40{2}1\/isrun{2}ing/i, // Cacaoweb
    /webap{2}sto{2}lbarba\.texthelp\.com\//i,
    /davebestdeals\.com\//i,
    /metrics\.itunes\.ap{2}le\.com\.edgesuite\.net\//i,
    /\.kaspersky-labs\.com\//i,
    /cdn{2}etwok\.xyz\//i
  ],
  release: environment.version
};

export default errorLoggerConfiguration;
